<template>
  <v-navigation-drawer v-model="model" location="end" temporary :width="drawerWidth" color="surface"
    class="rb-navigation-drawer">
    <div class="drawer-resizer" @mousedown="startResize"></div>

    <div class="drawer-layout">
      <v-toolbar color="surface" density="comfortable" flat class="drawer-header">
        <v-avatar color="rb-primary-light" rounded="lg" size="36" class="ml-4 mr-3">
          <v-icon icon="mdi-information-outline" color="primary" size="20" />
        </v-avatar>

        <v-toolbar-title class="text-subtitle-1 font-weight-bold drawer-title">
          {{ title }}
        </v-toolbar-title>

        <v-spacer />

        <v-btn prepend-icon="mdi-close" variant="text" class="mr-3" color="error" aria-label="Close drawer"
          @click="model = false">
          <v-tooltip activator="parent" location="bottom">
            Close
          </v-tooltip>
        </v-btn>
      </v-toolbar>

      <v-divider />

      <div class="drawer-body font-weight-bold">
        <slot />
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "RbNavigationDrawer",

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },

    width: {
      type: [String, Number],
      default: 350,
    },

    title: {
      type: String,
      default: "Drawer",
    },
  },

  emits: ["update:modelValue"],

  data() {
    return {
      drawerWidth: this.width,
      isResizing: false,
    };
  },

  computed: {
    model: {
      get() {
        return this.modelValue;
      },

      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },

  beforeUnmount() {
    this.stopResize();
  },

  methods: {
    startResize(event) {
      if (event.button !== 0) return;

      event.preventDefault();

      this.isResizing = true;

      document.addEventListener("mousemove", this.resizeDrawer);
      document.addEventListener("mouseup", this.stopResize);

      document.body.style.cursor = "ew-resize";
      document.body.style.userSelect = "none";
    },

    resizeDrawer(event) {
      if (!this.isResizing) return;

      const newWidth = window.innerWidth - event.clientX;
      const maxWidth = Math.min(900, window.innerWidth);

      this.drawerWidth = Math.max(
        Math.min(newWidth, maxWidth),
        Math.min(300, maxWidth)
      );
    },

    stopResize() {
      this.isResizing = false;

      document.removeEventListener("mousemove", this.resizeDrawer);
      document.removeEventListener("mouseup", this.stopResize);

      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    },
  },
};
</script>

<style scoped>
.rb-navigation-drawer {
  border-left: 1px solid rgb(var(--v-theme-rb-border));
}

.drawer-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.drawer-header {
  flex-shrink: 0;
}

.drawer-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.drawer-resizer {
  position: absolute;
  left: 0;
  top: 0;
  width: 6px;
  height: 100%;
  cursor: ew-resize;
  z-index: 10;
}

.drawer-resizer:hover {
  background: #ffb000;
}

:deep(.v-navigation-drawer__content) {
  overflow: hidden;
}
</style>